import {
  Facebook,
  Instagram,
  Youtube,
  Phone,
  MapPin,
  BadgeCheckIcon,
} from 'lucide-react';
import { Link } from 'react-router-dom';
import { useState } from 'react';
import FeedbackModal from './Forms/FeedBackModal';

const Footer = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <footer className="footer-container-fb">
        <div className="footer-top-fb">
          {/* Branding */}
          <div className="footer-logo-fb">
            <h2>Get Propertys</h2>
            <p>Crafting premium real estate and insurance experiences just for you.</p>
          </div>

          {/* Our Services */}
          <div className="footer-services-fb">
            <h4>Our Services</h4>
            <ul>
              <li>Sale / Purchase of Flats</li>
              <li>Under Construction & Resale Deals</li>
              <li>Rental & Leasing</li>
              <li>Land Deals & Investment</li>
              <li>Legal & Loan Assistance</li>
            </ul>
          </div>

          {/* Quick Links */}
          <div className="footer-links-fb">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about-us">About</Link></li>
              <li><Link to="/properties">Projects</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li onClick={() => setOpen(true)} style={{ cursor: 'pointer' }}>Feedback</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-contact-fb">
            <h4>Contact Us</h4>
            <p><Phone size={16} /> 76666 96677 / 92222 26977</p>
            <p><MapPin size={16} /> 241/43, Maharaja Bldg., 2nd Floor, Opp. Girgaum Church, Mumbai – 400 004</p>
            <p><BadgeCheckIcon size={16} /> MAHA RERA: A011242400062</p>
          </div>
        </div>

        {/* Social Media */}
        <div className="footer-social-section-fb">
          <h4>Follow Us</h4>
          <div className="footer-icons-fb">
            <a href="https://www.facebook.com/kamblevinayak200?mibextid=LQQJ4d" target="_blank" rel="noreferrer" aria-label="Facebook">
              <Facebook size={20} />
            </a>
            <a href="https://www.instagram.com/vinayak_kamble_200" target="_blank" rel="noreferrer" aria-label="Instagram">
              <Instagram size={20} />
            </a>
            <a href="https://youtube.com/@propertywala6677?si=xQXQ9PfgRkvsgX6k" target="_blank" rel="noreferrer" aria-label="YouTube">
              <Youtube size={20} />
            </a>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom-fb">
          <p>
            © {new Date().getFullYear()} All rights reserved, Powered By{' '}
            <a
              href="https://100billiontech.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              100billion Tech
            </a>
          </p>
        </div>
      </footer>

      <FeedbackModal isOpen={open} onClose={() => setOpen(false)} />
    </>
  );
};

export default Footer;
